<div class="video-overlay" *ngIf="videoUrl">
    <button type="button" mat-icon-button (click)="close.emit()">
        <img src="./assets/images/icons/ic_close.svg" alt="">
    </button>
    <video #videoElement [src]="videoUrl" autoplay controls loop disablePictureInPicture ></video>
    <p>{{title}}</p>
</div>